import { connect } from 'react-redux';
import { ApplicationState } from '~/Store';

import { login } from './actions';
import LoginPage from './LoginPage';

function mapStateToProps(state: ApplicationState): { isFetching: boolean } {
	return {
		isFetching: state.accessToken.isFetching,
	};
}

const actions = {
	onLogin: login,
};

export default connect(mapStateToProps, actions)(LoginPage);
